import React from 'react'

import Sales from '../Sales'
import { Button } from '@mui/material'
import { Link, useLocation, useParams } from 'react-router-dom'
import { PlaylistAddCheckCircle, PlaylistAddCircle } from '@mui/icons-material'
import { Toaster } from 'react-hot-toast'

const SalesRetur = ({ children }) => {

    const { username } = useParams();
    const location = useLocation();
    const path = location.pathname;
    const split = path.split('/');

    return (
        <Sales>
            <Toaster position="top-center" />
            <div className="mt-3">
                <div className="card">
                    <div className="card-body">
                        <div className="sub-menu">
                            <ul>
                                <li>
                                    <Link to={`/${username}/sales/retur/data`} className={` sub-menu-item ${split[4] === 'data'? 'active' : ''} `}>
                                        <div className="me-2">
                                            <PlaylistAddCircle />
                                        </div>
                                        <span>Data Retur</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/sales/retur/validasi`} className={` sub-menu-item ${split[4] === 'validasi'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Validasi</span>
                                    </Link>
                                </li>
                                <li>
                                    <Link to={`/${username}/sales/retur/form`} className={` sub-menu-item ${split[4] === 'form'? 'active' : ''} `} >
                                        <div className="me-2">
                                            <PlaylistAddCheckCircle />
                                        </div>
                                        <span>Kasir Retur</span>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            { children }
        </Sales>
    )
}

export default SalesRetur
